import styles from './reset-password-form.module.scss';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import useResetPasswordFormFeature from '../../../feature/reset-password-form-feature/reset-password-form-feature';

import { Button, Icon, IconEnum, InputType } from '@greenkub-fronts/shared/ui';

export function ResetPasswordForm() {
  const {
    register,
    handleSubmit,
    errors,
    onSubmit,
    focusedField,
    isPasswordVisible,
    onPasswordVisibleToggle,
    successMsg,
    errorMsg,
    isLoading,
  } = useResetPasswordFormFeature();

  return (
    <form className={styles['LoginForm']} onSubmit={handleSubmit(onSubmit)}>
      <div
        className={cx(
          styles['FormInput'],
          focusedField === 'password' && styles['IsFocused']
        )}
      >
        <input
          type={isPasswordVisible === false ? 'password' : 'text'}
          placeholder="Nouveau mot de passe"
          defaultValue=""
          {...register('password', { required: true })}
        />
        <Button
          className={cx(
            styles['LoginToggleVisiblePassword'],
            styles['IconButton']
          )}
          onClick={() => onPasswordVisibleToggle()}
          // tabIndex={-1}
        >
          {isPasswordVisible === false ? (
            <Icon name={IconEnum.VISIBILITY} />
          ) : (
            <Icon name={IconEnum.VISIBILITY_OFF} />
          )}
        </Button>
      </div>

      {/* ERREUR SUR PASSWORD */}
      {errors?.password?.type === 'required' && (
        <p className={styles['ErrorMessage']}>Ce champ est requis</p>
      )}

      <div
        className={cx(
          styles['FormInput'],
          focusedField === 'passwordConfirmation' && styles['IsFocused']
        )}
      >
        <input
          type={isPasswordVisible === false ? 'password' : 'text'}
          {...register('passwordConfirmation', { required: true })}
          placeholder="Répéter le mot de passe"
        />
      </div>

      {/* ERREUR SUR PASSWORD */}
      {errors?.passwordConfirmation?.type === 'required' && (
        <p className={styles['ErrorMessage']}>Ce champ est requis</p>
      )}

      <div className={styles['LoginActions']}>
        <Link to="/login">Connexion</Link>
      </div>

      <div>
        <p className={cx(styles['FormMsg'], styles['IsError'])}>{errorMsg}</p>
      </div>
      <div>
        <p className={cx(styles['FormMsg'], styles['IsSuccess'])}>
          {successMsg}
        </p>
      </div>

      <Button
        className={styles['LoginSubmit']}
        inputType={InputType.SUBMIT}
        loading={isLoading}
        label="Réinitialiser mon mot de passe"
      />
    </form>
  );
}

export default ResetPasswordForm;
